import settings from '@/settings'

const criarCobrancaImediata = (headers, payload) => {
  return fetch(`${settings.apiPayment}/inter/pix/`, {
    method: 'POST',
    body: JSON.stringify(payload),
    mode: 'cors',
    headers: headers
  })
}

const cancelarCobrancaImediata = (headers, payload) => {
  return fetch(`${settings.apiPayment}/inter/pix/cancelar/`, {
    method: 'POST',
    body: JSON.stringify(payload),
    mode: 'cors',
    headers: headers
  })
}

const pegarCobrancaImediata = (headers, payload) => {
  let url = `${settings.apiPayment}/inter/pix/`
  if (payload) {
    const keys = Object.keys(payload)
    for (let i = 0; i < keys.length; i++) {
      url = `${url}${url[url.length - 1] === '/' ? '?' : '&'}${keys[i]}=${payload[keys[i]]}`
    }
  }

  return fetch(url, {
    method: 'GET',
    mode: 'cors',
    headers: headers
  })
}

export default {
  criarCobrancaImediata,
  pegarCobrancaImediata,
  cancelarCobrancaImediata
}
